module.exports = __webpack_public_path__ + "img/ba0cf60.png";